import { inject, Injectable, InjectionToken } from '@angular/core';
import { ENVIRONMENT } from '../../../environments/environment.interface';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiRole } from '../api-types/role.api';
import { Role } from '../app-types/role.app';
import { transformApiRolesToAppRoles } from '../transformers/role.transform';
import { BaseRequestService } from './base-request.service';

export const ROLE_SERVICE = new InjectionToken<RoleService>('ROLE_SERVICE');

@Injectable()
export class RoleService extends BaseRequestService {
	private readonly env = inject(ENVIRONMENT);

	public async getAll() {
		const response = await this.get<PaginatedResponse<ApiRole>>('roles', { range: this.env.roleQueryRange });
		const roles = transformApiRolesToAppRoles(response.entities);
		const page: PaginatedResponse<Role> = {
			entities: roles,
			offset: response.offset,
			range: response.range,
			totalEntities: response.totalEntities,
		};
		return page;
	}
}
